document.addEventListener('DOMContentLoaded', function () {
  $('.animate__fadeInUp').each(function (index, item) {
    let target = $(item).offset().top;
    if (target < $(window).height()) {
      $(item).css({ 'animation-name': 'fadeInUp', visibility: 'visible' });
    } else {
      $(window).scroll(function () {
        let scrollTop = $(window).scrollTop();
        if (scrollTop > target - $(window).height()) {
          $(item).css({ 'animation-name': 'fadeInUp', visibility: 'visible' });
        }
      });
    }
  });
});